/**
 * Анимирована ли картинка — по разметке файла, как на сервере (isAnimated в backend/internal/api/guildimages.go):
 * у WebP — флаг анимации в заголовке VP8X, у PNG — блок acTL раньше первого IDAT. GIF считается анимацией
 * всегда: его и раньше отправляли как есть, а кадры сервер посчитает сам.
 */
export function isAnimatedBytes(head: Uint8Array): boolean {
  const at = (i: number, s: string) => [...s].every((c, k) => head[i + k] === c.charCodeAt(0))
  if (at(0, 'GIF8')) return true
  if (at(0, 'RIFF') && at(8, 'WEBP')) return at(12, 'VP8X') && ((head[20] ?? 0) & 0x02) !== 0
  if (head[0] === 0x89 && at(1, 'PNG')) {
    const actl = indexOf(head, 'acTL')
    const idat = indexOf(head, 'IDAT')
    return actl >= 0 && (idat < 0 || actl < idat)
  }
  return false
}

function indexOf(bytes: Uint8Array, s: string): number {
  const first = s.charCodeAt(0)
  for (let i = bytes.indexOf(first); i >= 0 && i <= bytes.length - s.length; i = bytes.indexOf(first, i + 1)) {
    let k = 1
    while (k < s.length && bytes[i + k] === s.charCodeAt(k)) k++
    if (k === s.length) return i
  }
  return -1
}

/** То же для файла: хватает начала — заголовки и acTL стоят в первых килобайтах. */
export async function isAnimatedFile(file: Blob): Promise<boolean> {
  return isAnimatedBytes(new Uint8Array(await file.slice(0, 1 << 16).arrayBuffer()))
}
